import { render, staticRenderFns } from "./PoRequest.vue?vue&type=template&id=2f6583a8&"
import script from "./PoRequest.vue?vue&type=script&lang=js&"
export * from "./PoRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports